import EventEmitter from 'eventemitter3';

import { type SocketInterface, type YjsSocketEvents } from './socket';

export class NoopTestSocket
  extends EventEmitter<YjsSocketEvents>
  implements SocketInterface
{
  send(): void {}
  restart(): void {}
  destroy(): void {}
  async connect(): Promise<void> {}
  open = false;
  state = 'init' as const;
}
